import React, { useState } from 'react'
import { cloneDeep } from 'lodash'
import { Button, Grid } from '@material-ui/core'
import { SelectInput } from '@crystalservice/crystals-ui/lib/components/inputs/select-input/select-input'
import { NOT_SELECTED_VALUE } from '../registration-form'
import { ChildrenRow } from './children-row'
import { Child, ChildGender, emptyChild, isChildrenListEmpty } from './utils'

const styles = require('./../registration-page.module.scss')

interface ChildrenSelectionProps {
    id: string
    required: boolean
    value: Child[]
    onValueChange: (value: Child[], id: string) => void
}

export const ChildrenSelection: React.FC<ChildrenSelectionProps> = ({
    id,
    required,
    value,
    onValueChange,
}) => {
    const [childrenExist, setChildrenExist] = useState(() => {
        if (value == null) {
            return NOT_SELECTED_VALUE
        }

        if (value && value?.length === 0 ) {
            return 'false'
        }

        if (value?.length > 0 ) {
            return 'true'
        }
    })

    const [childrenList, setChildrenList] = useState(value)

    const onAdd = () => {
        let children = cloneDeep(childrenList)

        if (isChildrenListEmpty(children)) {
            children = []
        }

        children.push({
            name: '',
            birthDate: null,
            gender: ChildGender.Unknown
        })
        onValueChange(children, 'children')
        setChildrenList(children)
    }

    return (
        <Grid container spacing={2} direction="column">
            <Grid item>
                <SelectInput
                    id={`registrationField-${id}-isExist`}
                    className={styles.select}
                    required={required}
                    value={childrenExist}
                    options={[
                        {
                            value: NOT_SELECTED_VALUE,
                            label: 'Не заполнено'
                        },
                        {
                            value: 'true',
                            label: 'Есть'
                        },
                        {
                            value: 'false',
                            label: 'Нет'
                        },
                    ]}
                    onSelect={option => {
                        setChildrenExist(option.value)

                        if (option.value === NOT_SELECTED_VALUE) {
                            onValueChange(null, id)
                            setChildrenList(null)
                        }

                        if (option.value === 'true') {
                            onValueChange([emptyChild], id)
                        }

                        if (option.value === 'false') {
                            onValueChange([], id)
                            setChildrenList([])
                        }
                    }}
                />
            </Grid>
            {(childrenList && !isChildrenListEmpty(childrenList)) && (
                <>
                    {childrenList?.map((child: Child, index: number) => (
                        <ChildrenRow
                            key={index}
                            index={index}
                            child={child}
                            childrenList={childrenList}
                            onValueChange={onValueChange}
                            setChildrenList={setChildrenList}
                        />
                    ))}
                </>
            )}

            <Grid item>
                {childrenExist === 'true' && (
                    <Button
                        color="primary"
                        className="addChildButton"
                        onClick={onAdd}
                    >
                        Добавить ребенка
                    </Button>
                )}
            </Grid>
        </Grid>
    )
}
